interface IOperationListType {
  key: string;
  label: string;
  img: string;
  redirectUrl: string;
  rightLabel?: string;
}

// 基础节点类型
interface BaseNode {
  id: string;
  code: string | null;
  name: string;
  parentId: string;
  category: string;
  customerName: string | null;
  customerId: string | null;
  haveCardMeter: string; // 注意：实际数据中是字符串形式的布尔值 "true"/"false"
  children: TreeNode[] | null;
}
// 树节点类型key
export enum categoryTypeEnum {
  COMMUNITY_ID = 'communityId',
  REGION_ID = 'regionId',
  FLOOR_ID = 'floorId',
  UNIT_ID = 'unitId',
}

// 社区节点类型
export interface CommunityNode extends BaseNode {
  category: 'community';
}

// 片区节点类型
export interface RegionNode extends BaseNode {
  category: 'region';
}
// 单元节点类型
export interface UnitNode extends BaseNode {
  category: 'unit';
}
// 楼层节点类型
export interface FloorNode extends BaseNode {
  category: 'floor';
}
// 房间节点类型
export interface RoomNode extends BaseNode {
  category: 'room';
}
// 通用树节点类型（联合类型）
export type TreeNode = CommunityNode | RegionNode;

export const operationList: IOperationListType[] = [
  {
    label: '待审核',
    key: '1',
    img: require('@/assets/user/Group 427320643@2x.png'),
    redirectUrl: '/warranty',
  },
  {
    label: '处理中',
    key: '2',
    img: require('@/assets/user/Group 427320644@2x.png'),
    redirectUrl: '/warranty',
  },
  {
    label: '被退回',
    key: '3',
    img: require('@/assets/user/Group 427320645@2x.png'),
    redirectUrl: '/warranty',
  },
  {
    label: '已关闭',
    key: '4',
    img: require('@/assets/user/Group 427320646@2x.png'),
    redirectUrl: '/warranty',
  },
  {
    label: '已完成',
    key: '5',
    img: require('@/assets/user/Group 427320646@2x(1).png'),
    redirectUrl: '/warranty',
  },
  {
    label: '已撤销',
    key: '6',
    img: require('@/assets/user/payBack.png'),
    redirectUrl: '/warranty',
  },
];

export const UserMoreOperationList: IOperationListType[] = [
  {
    label: '个人资料',
    key: '1',
    img: require('@/assets/user/Frame@2x.png'),
    redirectUrl: '/personData',
    rightLabel: '',
  },
  {
    label: '个人账户',
    key: '4',
    img: require('@/assets/user/Frame@2x.png'),
    redirectUrl: '/accountInformation',
    rightLabel: '',
  },
  {
    label: '个人资产',
    key: '2',
    img: require('@/assets/user/Frame@2x(1).png'),
    redirectUrl: '/personAsset',
    rightLabel: '去绑定',
  },
  {
    label: '修改密码',
    key: '3',
    img: require('@/assets/user/Frame@2x(2).png'),
    redirectUrl: '', // /payment/record
    rightLabel: '',
  },
];
